import isPersonalNumberFunc from "../validations/is.personal.number";

const isPersonalNumber = (values, value) => isPersonalNumberFunc(value);
export default isPersonalNumber;
